import { ESex } from '../../hooks/auth/models';
import { ECompanyOrAssociationStatus } from '../user/UserInfosModel';
import { UpdateByAdminCompanyAssociationInformationsResponse } from '../responses/UpdateByAdminCompanyAssociationInformationsResponse';

export interface UpdateByAdminCompanyAssociationInformationsDTO {
    userId: string;
    nomeAziendaAssociazione?: string;
    addressSedeLegale?: string;
    citySedeLegale?: string;
    capSedeLegale?: number;
    provinciaSedeLegale?: string;
    nationSedeLegale?: string;
    email?: string;
    mailRichiestePubblicheAziendale?: string;
    telephone?: string;
    codiceFiscaleAziendale?: string;
    partitaIvaVat?: string;
    websiteAziendale?: string;
    telefonoAziendale?: string;
    socialLink?: string;
    websiteSottoscrizioneAssociazioni?: string;
    nome?: string;
    cognome?: string;
    sex?: ESex;
    born?: Date;
    codiceFiscale?: string;
    comuneDiNascita?: string;
    statoDiNascita?: string;
    companyOrAssociationStatus: ECompanyOrAssociationStatus;
    enabledUser: boolean;
    conventioned: boolean;
    isNationalReference: boolean;
}

export const mapToUpdateByAdminCompanyAssociationInformationsDTO = (response: UpdateByAdminCompanyAssociationInformationsResponse): UpdateByAdminCompanyAssociationInformationsDTO => {
    return {
        userId: response.userId,
        nomeAziendaAssociazione: response.nomeAziendaAssociazione,
        addressSedeLegale: response.addressSedeLegale,
        citySedeLegale: response.citySedeLegale,
        capSedeLegale: response.capSedeLegale,
        provinciaSedeLegale: response.provinciaSedeLegale,
        nationSedeLegale: response.nationSedeLegale,
        email: response.email,
        mailRichiestePubblicheAziendale: response.mailRichiestePubblicheAziendale,
        telephone: response.telephone,
        codiceFiscaleAziendale: response.codiceFiscaleAziendale,
        partitaIvaVat: response.partitaIvaVat,
        websiteAziendale: response.websiteAziendale,
        telefonoAziendale: response.telefonoAziendale,
        socialLink: response.socialLink,
        websiteSottoscrizioneAssociazioni: response.websiteSottoscrizioneAssociazioni,
        nome: response.nome,
        cognome: response.cognome,
        sex: response.sex,
        born: response.born,
        codiceFiscale: response.codiceFiscale,
        comuneDiNascita: response.comuneDiNascita,
        statoDiNascita: response.statoDiNascita,
        companyOrAssociationStatus: response.companyOrAssociationStatus,
        enabledUser: response.enabledUser,
        conventioned: response.conventioned,
        isNationalReference: response.isNationalReference,
    };
}; 